import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { folder } from '../../../../../../../../shared/assets/emojis';

import { Emoji, DocumentsBox, ProgressCircle, FadeIn, FileInputContainer, FileInput, UploadedFile, SelectInputFile } from 'hosman-material';

import { getDocuments, getDocumentTypes, fileEdit, addInput, updateInputs, addDocument, deleteDocument, handleDocChanges } from '../../../../../../../reducers/SellerApp/documentsSlice';

const DocumentsTab = () => {
  const { groupedDocumentTypes, addedInputs, docTypeInfos, mandatoryDocs, uploadedOptionalDocs, allDocs, isLoading, lastDocumentUpload } = useSelector((state) => state.sellerDocuments);
  const { user } = useSelector((state) => state.user);
  const { sale } = useSelector((state) => state.sellerSales);
  const [uploadProgression, setUploadProgression] = useState(0);
  const [propertyKindGroup, setPropertyKindGroup] = useState('');
  const dispatch = useDispatch()

  useEffect(() => {
    if (!sale.id) return;
    const kindGroup = handlePropertyKindGroup(sale.property.kind)

    setPropertyKindGroup(kindGroup)
    dispatch(getDocuments(sale.id));
    dispatch(getDocumentTypes(kindGroup));
  }, [sale])

  useEffect(() => {
    if (Object.keys(groupedDocumentTypes).length === 0) return;

    dispatch(handleDocChanges(propertyKindGroup))
  }, [groupedDocumentTypes])

  useEffect(() => {
    if (!sale.id || mandatoryDocs.length === 0) return;

    const mandatoryDocsLength = mandatoryDocs.length
    const mandatoryDocsNotUploadedLength = mandatoryDocs.filter(doc => doc.documents.length > 0).length

    setUploadProgression(Math.floor((mandatoryDocsNotUploadedLength / mandatoryDocsLength) * 100));
  }, [mandatoryDocs])

  const handlePropertyKindGroup = (propertyKind) => {
    let group = null
    const apartmentGroup = ['apartment', 'duplex', 'triplex', 'loft']
    const houseGroup = ['house', 'mansion']

    if (apartmentGroup.includes(propertyKind)) group = 'apartment'
    if (houseGroup.includes(propertyKind)) group = 'house'

    return group || 'other'
  }

  const handleOptionChange = ({ id }) => {
    dispatch(addInput(id));
  }

  const handleUpload = async (file, dataFile) => {
    dispatch(fileEdit(dataFile))

    const form = new FormData();
    form.append('file', file);
    form.append('document_type_id', dataFile.id);

    try {
      const resultAction = await dispatch(addDocument({ saleId: sale.id, form: form }));

      if (addDocument.fulfilled.match(resultAction)) {
        dispatch(updateInputs(dataFile));
      }
    } catch (error) {
      console.error("Erreur lors de l'upload du document :", error);
    }
  }

  const documentCanBeDeleted = (document) => {
    return document.uploader_id === user.id && sale.state === 'awaiting_publication'
  }

  return (
    <FadeIn>
      <div className='flex flex-col items-center w-fill md:mx-24' data-testid='DocumentsTab'>
        <div className='h2 text-ih-indigo flex justify-around my-10'>
          <div className='flex flex-col md:flex-row items-center gap-4'>
            <Emoji emojiSrc={folder} width='w-8' />
            <p>Vos documents de vente</p>
            {propertyKindGroup !== 'other' && <ProgressCircle value={uploadProgression} />}
          </div>
        </div>

        {Object.entries(groupedDocumentTypes).map(([categorySlug], index) => (
          <div key={`${categorySlug}-${index}`} className='w-full'>
            <DocumentsBox emoji={docTypeInfos[categorySlug].emoji} title={docTypeInfos[categorySlug].name} >
              <div className='md:p-5 grid grid-cols-1 md:grid-cols-2 gap-8'>
                {mandatoryDocs.map((doc, index) => (
                  doc.category_slug === categorySlug &&
                  <FileInputContainer
                    key={`${doc.id}-${index}`}
                    name={doc.name}
                    uploaded={doc.documents.length > 0}
                    mandatory={doc[`mandatory_${sale?.property?.kind}`] === true}>
                    {doc.documents.length > 0 ?
                      doc.documents.map((file, index) => (
                        <UploadedFile
                          key={`${file.id}-${index}`}
                          file={file}
                          deleteAction={documentCanBeDeleted(file) && (() => dispatch(deleteDocument(file.id)))}
                        />
                      ))
                    :
                      <FileInput
                        key={`${doc.id}-${index}`}
                        name={doc.name}
                        dataFile={doc}
                        handleUpload={handleUpload}
                        isLoading={isLoading && lastDocumentUpload.id == doc.id} />
                    }
                  </FileInputContainer>
                ))}

                {uploadedOptionalDocs.map((doc, index) => (
                  doc.category_slug === categorySlug &&
                  <FileInputContainer
                    key={`${doc.id}-${index}`}
                    name={doc.name}
                    uploaded>
                      {doc.documents.map((file, index) => (
                        <UploadedFile
                          key={`${file.id}-${index}`}
                          file={file}
                          deleteAction={documentCanBeDeleted(file) && (() => dispatch(deleteDocument(file.id)))}
                        />
                      ))}
                  </FileInputContainer>
                ))}

                {Object.values(addedInputs[categorySlug]).length > 0 && Object.values(addedInputs[categorySlug]).map((input, index) => (
                  <FileInputContainer
                    key={`${input.id}-${index}`}
                    name={input.name}>
                      <FileInput
                        name={input.name}
                        dataFile={input}
                        handleUpload={handleUpload}
                        isLoading={isLoading && lastDocumentUpload.id == input.id} />
                  </FileInputContainer>
                ))}

                {allDocs.length > 1 &&
                  <SelectInputFile
                    label={categorySlug ==='diagnostic' ? "D'autres diagnostics individuels à nous transmettre ?" : "D'autres documents à nous transmettre ?"}
                    optionList={allDocs}
                    categorySlug={categorySlug}
                    handleChange={handleOptionChange}
                  />
                }
              </div>
            </DocumentsBox>
          </div>
        ))}
      </div>
    </FadeIn>
  )
}

export default DocumentsTab;
